import { render } from "./AddEditUsers.vue?vue&type=template&id=05f891a3"
import script from "./AddEditUsers.vue?vue&type=script&lang=js"
export * from "./AddEditUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__